import React from "react";
import SwitchButton from "../../../reusable/Button/SwitchButton";
import styles from "../ChartEditor.module.css";
import ChartType from "../../ChartType.json";

export const getConfigSwitch = (
	chartType,
	chartConfig,
	onChartConfigChange
) => {
	chartConfig = chartConfig || {};
	chartType = chartType || "";
	const configSwitch = {
		area: (
			<>
				<p>Show Area</p>
				<SwitchButton
					onClickMethod={() =>
						onChartConfigChange({
							...chartConfig,
							area: !chartConfig.area,
						})
					}
					checked={!!chartConfig.area || false}
				/>
			</>
		),
		point: (
			<>
				<p>Data Points</p>
				<SwitchButton
					onClickMethod={() =>
						onChartConfigChange({
							...chartConfig,
							point: !chartConfig.point,
						})
					}
					checked={!!chartConfig.point || false}
				/>
			</>
		),
		smooth: (
			<>
				<p>Smooth</p>
				<SwitchButton
					onClickMethod={() =>
						onChartConfigChange({
							...chartConfig,
							smooth: !chartConfig.smooth,
						})
					}
					checked={chartConfig.smooth || false}
				/>
			</>
		),
		label: (
			<>
				<p>Data Labels</p>
				<SwitchButton
					onClickMethod={() =>
						onChartConfigChange({
							...chartConfig,
							label: !chartConfig.label,
						})
					}
					checked={chartConfig.label || false}
				/>
			</>
		),
		outerLabel: (
			<>
				<p>Outer Label</p>
				<SwitchButton
					onClickMethod={() =>
						onChartConfigChange({
							...chartConfig,
							label: !chartConfig.label,
						})
					}
					checked={chartConfig.label || false}
				/>
			</>
		),
		slider: (
			<>
				<p>Enable Slider</p>
				<SwitchButton
					onClickMethod={() =>
						onChartConfigChange({
							...chartConfig,
							slider: !chartConfig.slider,
						})
					}
					checked={chartConfig.slider || false}
				/>
			</>
		),
		legend: (
			<>
				<p>Show Legend</p>
				<SwitchButton
					onClickMethod={() =>
						onChartConfigChange({
							...chartConfig,
							legend: !chartConfig.legend,
						})
					}
					checked={chartConfig.legend || false}
				/>
			</>
		),
		statistic: (
			<>
				<p>Show Statistic</p>
				<SwitchButton
					onClickMethod={() =>
						onChartConfigChange({
							...chartConfig,
							statistic: !chartConfig.statistic,
						})
					}
					checked={chartConfig.statistic || false}
				/>
			</>
		),
		stackField: (
			<>
				<p>Stack Field</p>
				<SwitchButton
					onClickMethod={() =>
						onChartConfigChange({
							...chartConfig,
							stackField: !chartConfig.stackField,
						})
					}
					checked={chartConfig.stackField || false}
				/>
			</>
		),
	};
	switch (chartType) {
		case ChartType.Radar:
		case ChartType.RadarMultiLine:
			return [
				<div key="area" className={styles.configSwitch}>
					{configSwitch.area}
				</div>,
				<div key="point" className={styles.configSwitch}>
					{configSwitch.point}
				</div>,
				<div key="smooth" className={styles.configSwitch}>
					{configSwitch.smooth}
				</div>,
			];
		case ChartType.BasicArea:
		case ChartType.StackedArea:
			return [
				<div key="point" className={styles.configSwitch}>
					{configSwitch.point}
				</div>,
				<div key="label" className={styles.configSwitch}>
					{configSwitch.label}
				</div>,
				<div key="slider" className={styles.configSwitch}>
					{configSwitch.slider}
				</div>,
				<div key="smooth" className={styles.configSwitch}>
					{configSwitch.smooth}
				</div>,
				<div key="legend" className={styles.configSwitch}>
					{configSwitch.legend}
				</div>,
			];
		case ChartType.BasicBar:
		case ChartType.StackedBar:
		case ChartType.RangeBar:
		case ChartType.PercentBar:
		case ChartType.GroupBar:
			return [
				<div key="label" className={styles.configSwitch}>
					{configSwitch.label}
				</div>,
				<div key="slider" className={styles.configSwitch}>
					{configSwitch.slider}
				</div>,
				<div key="legend" className={styles.configSwitch}>
					{configSwitch.legend}
				</div>,
			];
		case ChartType.ColumnLine:
			return [
				<div key="label" className={styles.configSwitch}>
					{configSwitch.label}
				</div>,
				<div key="legend" className={styles.configSwitch}>
					{configSwitch.legend}
				</div>,
			];
		case ChartType.Histogram:
			return [
				<div key="stack-field" className={styles.configSwitch}>
					{configSwitch.stackField}
				</div>,
			];
		case ChartType.BasicLine:
		case ChartType.MultiLine:
		case ChartType.StepLine:
			return [
				<div key="point" className={styles.configSwitch}>
					{configSwitch.point}
				</div>,
				<div key="label" className={styles.configSwitch}>
					{configSwitch.label}
				</div>,
				<div key="slider" className={styles.configSwitch}>
					{configSwitch.slider}
				</div>,
				<div key="smooth" className={styles.configSwitch}>
					{configSwitch.smooth}
				</div>,
				<div key="legend" className={styles.configSwitch}>
					{configSwitch.legend}
				</div>,
			];
		case ChartType.PieChart:
		case ChartType.DonutChart:
			return [
				<div key="legend" className={styles.configSwitch}>
					{configSwitch.legend}
				</div>,
				<div key="statistic" className={styles.configSwitch}>
					{configSwitch.statistic}
				</div>,
			];
		case ChartType.WordCloud:
			return null;
		default:
			return null;
	}
};
